// Authentication Configuration
// This file controls authentication settings for the application

export const AUTH_CONFIG = {
  // Email verification settings
  // NOTE: Email verification is controlled in Supabase Dashboard > Authentication > Settings
  // This flag only controls the UI messages shown to users
  // To disable email verification: Go to Supabase Dashboard > Authentication > Settings > Email Auth > Disable "Enable email confirmations"
  // To enable email verification: Go to Supabase Dashboard > Authentication > Settings > Email Auth > Enable "Enable email confirmations"
  EMAIL_VERIFICATION_REQUIRED: false, // This controls UI messages only
  
  // Profile completion requirements
  // Users must complete their profile before downloading data
  PROFILE_REQUIRED_FOR_DOWNLOADS: true,
  
  // Minimum password length
  MIN_PASSWORD_LENGTH: 6,
  
  // Session timeout (in milliseconds)
  SESSION_TIMEOUT: 24 * 60 * 60 * 1000, // 24 hours
} as const;

// Helper function to check if email verification is enabled
export const isEmailVerificationEnabled = (): boolean => {
  return AUTH_CONFIG.EMAIL_VERIFICATION_REQUIRED;
};

// Helper function to check if profile completion is required
export const isProfileRequired = (): boolean => {
  return AUTH_CONFIG.PROFILE_REQUIRED_FOR_DOWNLOADS;
};
